import { useEffect as c } from "react";
import { useNavigate as m, useSearchParams as u } from "react-router-dom";
function N({ to: i, replace: t, state: n, relative: o, preserveSearchParams: e }) {
  const a = m(), [r] = u(), s = i + (e && r.toString() ? `?${r.toString()}` : "");
  return c(
    () => a(s, { replace: t, state: n, relative: o }),
    [a, s, o, t, n]
  ), null;
}
export {
  N
};
//# sourceMappingURL=navigate-Ci9DmeN9.js.map
